module.exports = "<div class=\"modal-header\">\r\n  <h6>{{massage}}</h6>\r\n</div>\r\n\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"activeModal.close('Close click')\">\r\n    OK\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/common/alert-show/alert-show.component.html
// module id = ../../../../../src/app/content-page/common/alert-show/alert-show.component.html
// module chunks = main